import React from 'react'

import S from './MenuLogo.styled'
import Link from '../../../../modules/link/Link'
import { CrMark, CrLogo } from '../../../Svg'
import { useEnvDomain } from '../../../../hooks'
import { useHeaderContext } from '../../HeaderContext'
import { track } from '../../../../scripts/segment'

const MenuLogo = () => {
  const url = useEnvDomain()

  const { lightMode, enableTracking, pageOrScreen } = useHeaderContext()

  const onClick = () => {
    const actionDetail = {
      textOfButtonOrLink: 'Crunchyroll',
      pageOrScreen: pageOrScreen,
      position: 'top',
      referrer: window.location.href,
    }

    if (enableTracking) {
      track('Home Selected', actionDetail)
    }
  }

  return (
    <S.MenuLogo lightMode={lightMode} onClick={onClick}>
      <Link to={url} className="hidden-tablet">
        <div className="header-svg">
          <CrMark aria-hidden="true" aria-label="Crunchyroll Home" />
        </div>
      </Link>
      <Link to={url} className="hidden-mobile">
        <div className="header-svg">
          <CrLogo aria-hidden="true" aria-label="Crunchyroll Home" />
        </div>
      </Link>
    </S.MenuLogo>
  )
}

export default MenuLogo
